import { v4 as uuid } from 'uuid';
export var DiscountValidForOptions;
(function (DiscountValidForOptions) {
    DiscountValidForOptions["voucher"] = "voucher";
})(DiscountValidForOptions || (DiscountValidForOptions = {}));
export class Discount {
    id;
    companyId = null;
    discountStartDate = null;
    discountEndDate = null;
    enabled = false;
    name = null;
    percentage = 0;
    validFor = DiscountValidForOptions.voucher;
    constructor(id, data) {
        this.id = id || uuid();
        let definedKeys = Object.keys(this).filter((key) => key != "id");
        for (let key in data) {
            let value = data[key];
            let keyIsDefinedOnInstance = definedKeys.includes(key);
            if (keyIsDefinedOnInstance) {
                if (value) {
                    //replace all firebase dates with real dates
                    if (value.seconds && value.toDate) {
                        value = value.toDate();
                    }
                }
                Object.assign(this, { [key]: value });
            }
        }
    }
}
